import { connect } from 'react-redux';
import LeggerPeriode from '../../../views/Kurikulum/Raport/LeggerPeriode.view.js';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(LeggerPeriode);
